import React, { createContext, useContext, useEffect, useState } from 'react'
import { getPeriodoMesAtual } from '../services/util/date.service'

const DashboardContext = createContext()

const ORDENAR_ACOMPANHAMENTO_PICKING_DEFAULT = {
  label: 'Data Criação - Mais recente',
  value: 'data_criacao_desc',
}

const INITIAL_STATE = {
  acompanhamentoPicking: {
    selectedPeriodo: getPeriodoMesAtual(),
    searchText: '',
    ordenarPor: ORDENAR_ACOMPANHAMENTO_PICKING_DEFAULT,
    empresasSelecionadas: [],
  },
}

export const DashboardContextProvider = ({ children }) => {
  const [dashboardContext, setDashboardContext] = useState(INITIAL_STATE)
  const [acompanhamentoPickingContext, setAcompanhamentoPickingContext] = useState(
    dashboardContext.acompanhamentoPicking,
  )

  return (
    <DashboardContext.Provider
      value={{
        dashboardContext,
        setDashboardContext,
        acompanhamentoPickingContext,
        setAcompanhamentoPickingContext,
      }}
    >
      {children}
    </DashboardContext.Provider>
  )
}

export const useDashboardContext = () => {
  const { dashboardContext, setDashboardContext } = useContext(DashboardContext)
  return { dashboardContext, setDashboardContext }
}

export const useAcompanhamentoPickingContext = () => {
  const { setDashboardContext } = useContext(DashboardContext)
  const { acompanhamentoPickingContext, setAcompanhamentoPickingContext } =
    useContext(DashboardContext)

  useEffect(() => {
    setDashboardContext(prevDashboardContext => ({
      ...prevDashboardContext,
      acompanhamentoPicking: acompanhamentoPickingContext,
    }))
  }, [acompanhamentoPickingContext])

  return { acompanhamentoPickingContext, setAcompanhamentoPickingContext }
}
